/* eslint-disable class-methods-use-this */

import get from 'lodash/get';

import { ProposalDAOInterface, ProposalTextsDAOInterface } from '../ProposalDAO';
import BaseTextDAO from './BaseTextDAO';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';

export default class HTMLContentDAO extends BaseTextDAO implements ProposalTextsDAOInterface {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new HTMLContentDAO(proposal, proposalElement);
  }

  htmlContentDAOOptions?: ProposalNS.HTMLContentDAOOptions;

  filterItemsByIndexDAOOptions?: ProposalNS.FilterItemsByIndexDAOOptions;

  itemIndex?: number;

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  protected build(): void {
    // test for options
    const daoConfig: ProposalNS.HTMLContentConfig = this.proposalElement.DAO as ProposalNS.HTMLContentConfig;
    if (daoConfig.htmlContentDAOOptions !== undefined) {
      this.htmlContentDAOOptions = daoConfig.htmlContentDAOOptions;
    }

    const filter: ProposalNS.FilterItemsByIndexDAOOptions | undefined = daoConfig.filterItemsByIndexDAOOptions;
    if (filter !== undefined) {
      this.proposal.items.forEach((item, index) => {
        const localIndex: number =
          this.proposal.template.customParameters && this.proposal.template.customParameters.singleItemShift && this.proposal.items.length === 1
            ? index + 1
            : index;

        if (filter.itemIterator !== undefined && index === this.proposal.itemIterators.get(filter.itemIterator)) {
          this.itemIndex = index;
        }

        // absolute selection references must be relative to the singleItemShift, we use localIndex.
        if (filter.selection !== undefined && filter.selection.indexOf(localIndex) !== -1) {
          this.itemIndex = localIndex;
        }
      });
    }
  }

  getTexts(metadata?: ProposalNS.DAOGetTextsMetadata): ProposalNS.ProposalText[] {
    const out: ProposalNS.ProposalText[] = [];

    let { itemIndex } = this;
    if (itemIndex === undefined) {
      itemIndex = metadata ? metadata.itemIndex : undefined;
    }

    const textMetadata: ProposalNS.DAOGetTextsMetadata = {
      ...metadata,
      itemIndex,
      textRegex: this.htmlContentDAOOptions && this.htmlContentDAOOptions.textRegex,
    };

    if (this.htmlContentDAOOptions !== undefined) {
      if (this.htmlContentDAOOptions.html !== undefined) {
        for (const html of this.htmlContentDAOOptions.html) {
          const htmlStr: string = this.formatLocalizedString(html.content);
          const processedTextStr: string = this.processWildcards(htmlStr, textMetadata);

          out.push({
            text: processedTextStr,
            className: html.className,
            clamp: html.clamp,
            tag: html.tag,
          });
        }
      }

      if (this.htmlContentDAOOptions.conditional !== undefined) {
        const prop: string = this.htmlContentDAOOptions.conditional.property;
        const expressions: string[] = prop.split('.');
        if (expressions[0] === 'proposal') {
          expressions.shift();
          const result: unknown = get(this.proposal, expressions, undefined);

          let matchFound: boolean = false;
          for (const values of this.htmlContentDAOOptions.conditional.values) {
            for (const value of values.values) {
              if (result === value) {
                const htmlStr: string = this.formatLocalizedString(values.html.content);
                out.push({
                  text: htmlStr,
                  className: values.html.className,
                });
                matchFound = true;
                break;
              }
            }

            if (matchFound) {
              break;
            }
          }

          if (!matchFound && this.htmlContentDAOOptions.conditional.default !== undefined) {
            const htmlStr: string = this.formatLocalizedString(this.htmlContentDAOOptions.conditional.default.content);
            out.push({
              text: htmlStr,
              className: this.htmlContentDAOOptions.conditional.default.className,
            });
          }
        }
      }
    }

    return out;
  }
}
